import { render, staticRenderFns } from "./SubscribePanel.vue?vue&type=template&id=196264da&"
import script from "./SubscribePanel.vue?vue&type=script&lang=js&"
export * from "./SubscribePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports